"use strict";
/**
 *
 * Form
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FormContext_1 = require("./FormContext");
const form_1 = require("@domonda/form");
const fast_equals_1 = require("fast-equals");
const omit_1 = __importDefault(require("lodash/fp/omit"));
const merge_1 = __importDefault(require("lodash/fp/merge"));
function Form(props) {
    const { 
    // DomondaFormProps
    disabled = false, readOnly = false, defaultValues = {}, resetOnDefaultValuesChange, resetOnSuccessfulSubmit, resetOnFailedSubmit, onSubmit, autoSubmit, autoSubmitDelay, disableOnSubmit, getForm, 
    // component
    children } = props, rest = __rest(props, ["disabled", "readOnly", "defaultValues", "resetOnDefaultValuesChange", "resetOnSuccessfulSubmit", "resetOnFailedSubmit", "onSubmit", "autoSubmit", "autoSubmitDelay", "disableOnSubmit", "getForm", "children"]);
    const [form, dispose] = react_1.useMemo(() => {
        const [form, dispose] = form_1.createForm(defaultValues, {
            resetOnSuccessfulSubmit,
            resetOnFailedSubmit,
            onSubmit,
            autoSubmit,
            autoSubmitDelay,
            disableOnSubmit,
        });
        // if the state is initally different from the default one, change it during initialization
        if (form.state.disabled !== disabled || form.state.readOnly !== readOnly) {
            form.plumb.next(Object.assign(Object.assign({}, form.plumb.state), { disabled,
                readOnly }), form_1.FormTag.FORM_TOGGLE_DISABLE_OR_READ_ONLY);
        }
        return [form, dispose];
    }, []);
    const [formEl, setFormEl] = react_1.useState(null);
    react_1.useEffect(() => {
        form.configRef.current = {
            el: formEl,
            resetOnSuccessfulSubmit,
            resetOnFailedSubmit,
            onSubmit,
            autoSubmit,
            autoSubmitDelay,
            disableOnSubmit,
        };
    }, [
        formEl,
        resetOnSuccessfulSubmit,
        resetOnFailedSubmit,
        onSubmit,
        autoSubmit,
        autoSubmitDelay,
        disableOnSubmit,
    ]);
    react_1.useEffect(() => () => dispose(), []);
    // default values change
    react_1.useEffect(() => {
        if (!fast_equals_1.shallowEqual(form.state.defaultValues, defaultValues)) {
            const changedPaths = Object.keys(form.state.fields).filter((path) => form.state.fields[path].changed);
            form.plumb.next(Object.assign(Object.assign({}, form.state), { defaultValues, values: resetOnDefaultValuesChange
                    ? defaultValues // hard reset to default values
                    : merge_1.default(form.state.values, omit_1.default(changedPaths, defaultValues)) }), form_1.FormTag.DEFAULT_VALUES_CHANGE);
        }
    }, [defaultValues, resetOnDefaultValuesChange]);
    // disabled/readOnly change
    react_1.useEffect(() => {
        if (form.state.disabled !== disabled || form.state.readOnly !== readOnly) {
            form.plumb.next(Object.assign(Object.assign({}, form.state), { disabled,
                readOnly }), form_1.FormTag.FORM_TOGGLE_DISABLE_OR_READ_ONLY);
        }
    }, [disabled, readOnly]);
    react_1.useEffect(() => {
        if (getForm) {
            getForm(form);
        }
    }, [form, getForm]);
    return (react_1.default.createElement(FormContext_1.FormContext.Provider, { value: form },
        react_1.default.createElement("form", Object.assign({ autoComplete: "off" }, rest, { ref: setFormEl }), typeof children === 'function' ? children(form) : children)));
}
exports.Form = Form;
